import { AppState } from '../index';

export const selectGlobalPrices = (state: AppState) => state.global.prices;
export const selectGlobalMagicPrice = (state: AppState) => state.global.prices.MAGIC.price;
export const selectGlobalMagicUsdcPrice = (state: AppState) => state.global.prices.MAGIC_USDC.price;
export const selectGlobalCosmicPrice = (state: AppState) => state.global.prices.COSMIC.price;
export const selectSecretMode = (state: AppState) => state.global.secretMode;
export const selectGlobalNFTs = (state: AppState) => state.global.nfts;
export const selectGlobalItems = (state: AppState) => state.global.items;
